import { getSingleValueForTasField } from '../../utils/tuition-assistance/fields.ts';
import { hash } from '@ember/helper';
import isProgramRequired from '../../helpers/is-program-required.ts';
import isProgramVisible from '../../helpers/is-program-visible.ts';
import programLabelFor from '../../helpers/program-label-for.ts';
import type TasProgramTemplate from 'tio-data/models/tas-program-template';
import type { TASApplicationModelFieldsSignature } from 'tio-data/models/tas-application';
import type { TASCourseModelFieldsSignature } from 'tio-data/models/tas-course';
import type { TASProgramInstanceModelFieldsSignature } from 'tio-data/models/tas-program-instance';
import type { TASProgramTemplateModelFieldsSignature } from 'tio-data/models/tas-program-template';
import type { TemplateFieldName } from '../../utils/tuition-assistance/fields.ts';
import type { TOC } from '@ember/component/template-only';
import type TASProgramTemplateModel from 'tio-data/models/tas-program-template';

export interface S {
  Args: {
    fields:
      | TASProgramTemplateModelFieldsSignature
      | TASProgramInstanceModelFieldsSignature
      | TASApplicationModelFieldsSignature
      | TASCourseModelFieldsSignature;
    name: TemplateFieldName;
    programTemplate: TasProgramTemplate;
  };
  Blocks: {
    default: [
      {
        isVisible: boolean;
        isRequired: boolean;
        programLabel: string;
        value: string | number | boolean | Record<string, unknown> | null;
        name: TemplateFieldName;
        programTemplate: TASProgramTemplateModel;
      },
    ];
  };
}

const TasProgramReadonlyField: TOC<S> = <template>
  {{! @glint-nocheck: This is hiding possible issues, but not sure how to fix errors }}
  {{#let
    (hash
      isVisible=(isProgramVisible @name programTemplate=@programTemplate)
      isRequired=(isProgramRequired @name programTemplate=@programTemplate)
      programLabel=(programLabelFor @name programTemplate=@programTemplate)
      singleValue=(getSingleValueForTasField @name @fields)
    )
    as |config|
  }}
    {{#if config.isVisible}}
      {{yield
        (hash
          isVisible=config.isVisible
          isRequired=config.isRequired
          programLabel=config.programLabel
          value=config.singleValue
          name=@name
          programTemplate=@programTemplate
        )
      }}
    {{/if}}
  {{/let}}
</template>;

export default TasProgramReadonlyField;
